import { useState} from 'react'
import { apiClient, buildAuthRequestConfig } from '../utils/apiClient';

const useDelete = () => {
    const [loading,setLoading] = useState(false);
    const [error,setError]  = useState(null);
    const [data,setData] = useState();

    const deleteItem = async (url) => {
        setLoading(true);
        setError(null);
        
        try {
            const res = await apiClient.delete(url, buildAuthRequestConfig());
            setData(res.data)
          // Handle successful deletion
        } catch (error) {
            setError(error);
          // Handle error
        } finally {
            setLoading(false);
        }
        };

    return {deleteItem,data,loading,error}
}

export default useDelete
